import template from './modalWarningDelegation.html';
import controller from './modalWarningDelegation.controller';
import './modalWarningDelegation.scss';

let modalWarningDelegationComponent = {
  restrict: 'E',
  bindings: {
    isMobileApp: '<',
    titleBody: '@',
    delegation: '<',
    urlDestination: '<',
  },
  template,
  controller,
};

export default modalWarningDelegationComponent;



// WEBPACK FOOTER //
// ./client/app/components/modalWarningDelegation/modalWarningDelegation.component.js